import React from 'react';
import { Heart } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
    
        <p className="copyright">
          © 2026 HolyBible365. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
